<ng-template #loadingOrError>
  @if (loading()) {
    <div>{{ 'components.header.loading' | translate }}</div>
  }
  @if (error()) {
    <div>{{ error() }}</div>
  }
</ng-template>

@if (magazine() && edition()) {
  <dhp-error-toast [message]="downloadError()" />
  <dhp-details-header
    [magazine]="magazine()"
    [edition]="edition()"
    [subtitle]="
      'common.editionTitle'
        | translate
          : { year: edition().year, edition: edition().edition_version }
    "
    [imageAlt]="'magazines.images.cover'"
  >
    <ng-container buttons>
      <!-- Close Subscription Button -->
      <dhp-subscribe-button
        [magazineId]="magazine().id"
        [userAccessLevel]="magazine().user_access"
      />
      <!-- View / Download Copy Button -->

      @if (
        magazine().user_access === UserAccessLevel.SEAT_ASSIGNED &&
        edition().pdf
      ) {
        <button
          class="btn-secondary btn flex w-full gap-1 md:w-auto lg:gap-2"
          (click)="downloadCopy()"
        >
          <span>{{ 'components.journalItem.downloadCopy' | translate }}</span>

          @if (downloadingEdition()) {
            <svg
              class="h-6 w-6 animate-spin"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v8H4z"
              ></path>
            </svg>
          } @else {
            <img
              class="h-6 w-6"
              [alt]="'pages.articles.alt.downloadIcon' | translate"
              src="/assets/icons/download.svg"
            />
          }
        </button>
      } @else if (magazine().media?.trial_issue) {
        <a
          class="btn-secondary btn flex w-full gap-1 md:w-auto lg:gap-2"
          [href]="magazine().media?.trial_issue?.url"
          target="_blank"
          download
        >
          <span>{{ 'components.journalItem.viewCopy' | translate }}</span>
          <img
            class="h-6 w-6"
            [alt]="'pages.articles.alt.downloadIcon' | translate"
            src="/assets/icons/download.svg"
          />
        </a>
      }
    </ng-container>
    <ng-container metadata>
      <div class="flex flex-col gap-10 text-base">
        <div class="flex flex-col gap-4">
          <div class="grid grid-cols-1 gap-2 md:grid-cols-12">
            <strong class="md:col-span-3">{{
              'common.citation' | translate
            }}</strong>
            <div class="md:col-span-9">
              {{ 'common.citationManner' | translate: citationManner }}
            </div>
          </div>
          <div class="grid grid-cols-1 gap-2 md:grid-cols-12">
            <strong class="md:col-span-3">{{
              'components.journalItem.publishedOn' | translate
            }}</strong>
            <div class="md:col-span-9">
              {{
                edition().published_at ?? edition().createdAt | localizedDate
              }}
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </dhp-details-header>
}
